module.exports = __webpack_public_path__ + "static/media/study 201119.7ce7d68b.png";